/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
export type FeedSettings_viewer$ref = any;
export type FeedSettings_viewer = {
    readonly userSurvey?: {
        readonly hasTakenSurvey: boolean | null;
    } | null;
    readonly " $refType": FeedSettings_viewer$ref;
};



const node: ReaderFragment = ({
    "kind": "Fragment",
    "name": "FeedSettings_viewer",
    "type": "Viewer",
    "metadata": null,
    "argumentDefinitions": [
        {
            "kind": "RootArgument",
            "name": "userId",
            "type": "String!"
        },
        {
            "kind": "RootArgument",
            "name": "hasUserId",
            "type": "Boolean"
        }
    ],
    "selections": [
        {
            "kind": "Condition",
            "passingValue": true,
            "condition": "hasUserId",
            "selections": [
                {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "userSurvey",
                    "storageKey": null,
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "userId",
                            "variableName": "userId"
                        }
                    ],
                    "concreteType": "UserSurvey",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "hasTakenSurvey",
                            "args": null,
                            "storageKey": null
                        }
                    ]
                }
            ]
        }
    ]
} as any);
(node as any).hash = 'd242cd4bb7f41ffb797c2117c65c98c9';
export default node;
